module.exports = __webpack_public_path__ + "img/nutrition_7.83a64b1b.jpg";